import { DEX_TYPE } from "@/config/constants";
import { getEnvAndDex } from "@/utils/get-env-and-dex";

export const useHealthdex = () =>{
	const { dex } = getEnvAndDex();

	const isHealthdex = DEX_TYPE.SGHEALTHDEX === dex;
	return isHealthdex;
}
